<div class="toaster-wrapper">
  <ng-container *ngFor="let toasterConfig of toasters">
    <tngh-toaster
      [config]="toasterConfig"
      (closeToaster)="removeToaster($event)"
      [@listAnimation]>
    </tngh-toaster>
  </ng-container>
</div>
